/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import objectPath from "object-path";
import React, { useContext, useEffect, useLayoutEffect, useMemo, useState } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { getBreadcrumbsAndTitle, useSubheader } from "../../_core/MetronicSubheader";
import AuthService from "../../../../app/base/services/authentication.service";
import { UserRolesEnum, translateRoleName } from "../../../../app/pages/auth/userRoles.enum";
import { ChevronDown, GoBack, UserIcon } from "../../../../app/assets/icons";
import { Avatar, Spin } from "antd";
import { NotificationContext } from "./notificationContext/NotificationContext";
import NotificationPopover from "./components/NotificationPopover";
import LanguageSwitcher from "./components/LanguageSwitcher";
import "./style.css";
import { httpService } from "../../../../app/base/services/httpService.service";
import Axios from "axios";
import { useResultStore } from "../../components/useResultStore";
import PopoverLinks from "./components/PopoverLinks";
import { usePopoverStore } from "./store/usePopoverStore";
import { useAvatarStore } from "../header-mobile/store/useAvatarStore";
import { useTranslation } from "../../../../app/i18n/LanguageContext";
import { useDashboardStore } from "../../../../app/pages/workspace/actionPlanDashboard/store/dashboardStore";
// import { useAvatarStore } from "../header-mobile/store/useAvatarStore";


export function SubHeader() {
   const { t } = useTranslation();
   const uiService = useHtmlClassService();
   const navigate = useNavigate();
   const location = useLocation();
   const subheader = useSubheader();
   const { fullNameChanged } = useResultStore();

   const { anchorEl, closePopover, handleClick } = usePopoverStore();
   const isDashboardEditMode = useDashboardStore((state) => state.isEditMode);
   const setDashboardEditMode = useDashboardStore((state) => state.setEditMode);

   const user = AuthService?.getUser();
   const [fullName, setFullName] = useState(AuthService?.getFullName());
   const isDonor = AuthService.isAuthorized([UserRolesEnum.Donor]);
   const isSuperAdmin = AuthService.isAuthorized([UserRolesEnum.SuperAdmin]);
   const isNgo = AuthService.isAuthorized([UserRolesEnum.NationalOrganization]);
   const savedRecord = localStorage.getItem("selectedRecord");
   const isDetailPage = location.pathname.includes("/admin/organization/detail");
   const isViewActionPlan =
      location.pathname.includes("/view") && location.pathname.includes("action-plan");
   const isWorkspaceDetail =
      location.pathname.includes("/workspace/") || location.pathname.includes("/help-desk");
   // Resources page shows a breadcrumb ("Workspace / Resources" or
   // "Workspace / Collections") instead of the generic back-link the rest
   // of /workspace/* routes fall back to via isWorkspaceDetail above.
   const isResourcesPage = location.pathname.includes("/workspace/resources");
   const resourcesActiveTab =
      new URLSearchParams(location.search).get("tab") === "collections"
         ? "collections"
         : "resources";
   const isEditSurveyDetail =
      location.pathname.includes("/admin/module/edit-survey-details") ||
      location.pathname.includes("/admin/module/add") ||
      location.pathname.includes("/admin/module/import") ||
      location.pathname.includes("/admin/module/edit/") ||
      location.pathname.includes("/admin/module/test/");
   const isTemplatePreview = location.pathname.includes("/admin/template/test/");
   const isEditSurveyPreview =
      location.pathname.includes("/admin/module/test/") &&
      AuthService.isAuthorized([UserRolesEnum.SuperAdmin]);
   const isEditAssessment =
      location.pathname.includes("/admin/assessment/edit") ||
      location.pathname.includes("/admin/assessment/add");
   // The self-assessment module view is served at
   // /workspace/assessment/self-assessment/:assessmentId/survey/:surveyId, so match
   // on the `/survey/` segment (not `/module/`, which this route never uses).
   const isSelfAssessment =
      location.pathname.includes("/workspace/assessment/self-assessment/") &&
      location.pathname.includes("/survey/");
   // Assessment id pulled from the URL so the back link returns to that assessment's
   // full module list (/workspace/assessment/self-assessment/:assessmentId).
   const selfAssessmentId = isSelfAssessment
      ? location.pathname.split("/workspace/assessment/self-assessment/")[1]?.split("/")[0]
      : null;
   const isStaffActionPlan =
      location.pathname.includes("/workspace/results/action-plan-member/") &&
      location.pathname.includes("/module/");
   const isManagerActionPlan =
      location.pathname.includes("/workspace/survey-request/") &&
      location.pathname.includes("/survey/");
   // Expert guided assessments: "Workspace / Guided assessments" on the list and
   // "Workspace / Guided assessments / Assessment" on an assessment's page.
   const isExpertGuidedList =
      AuthService.isAuthorized([UserRolesEnum.Consultant]) &&
      location.pathname.startsWith("/workspace/assessment/guided-assessment/list");
   const isExpertGuidedAssessment =
      AuthService.isAuthorized([UserRolesEnum.Consultant]) &&
      location.pathname.startsWith("/workspace/assessment/guided-assessment/surveys/");
   // Staff opening a module from Task management gets a "Task management / Module" breadcrumb.
   const isStaffModulePreview =
      AuthService.isAuthorized([UserRolesEnum.Staff]) &&
      location.pathname.includes("/workspace/results/action-plan-member/") &&
      location.pathname.includes("/survey/");
   // The Approver's own module review screen is at /approver/submissions/:id -
   // distinguish it from the list itself (/approver/submissions, no trailing id).
   const isApproverModuleReview =
      AuthService.isAuthorized([UserRolesEnum.Approver]) &&
      location.pathname.startsWith("/approver/submissions/");
   const isORGManagementInDonor =
      location.pathname.includes("/workspace/organization-management/details/") && isDonor;
   const isSuperAdminManagement =
      location.pathname.includes("/workspace/organization-management/details/") && isSuperAdmin;
   const isGuidedAssessmentInExpert =
      location.pathname.includes("/workspace/assessment/guided-assessment/") &&
      location.pathname.includes("/module/");
   const isGuidedAssessmentExpert = location.pathname.includes(
      `/workspace/assessment/guided-assessment/surveys/`
   );
   const isActionPlanManager = location.pathname.includes("/survey-results");
   const isConsultantORGView =
      AuthService.isAuthorized([UserRolesEnum.Consultant]) &&
      location?.pathname?.includes("/workspace/results/action-plan/organization/");

   const isAdminTickets =
      location?.pathname?.includes("/admin/help-desk/list") ||
      location?.pathname?.includes("/admin/help-desk/details/");

   // Ticket preview page (admin and workspace) — shows a "back to
   // Tickets/Help Desk" link in the header instead of an in-page
   // breadcrumb, matching every other detail/edit page below.
   const isTicketDetails =
      location?.pathname?.includes("/admin/help-desk/details/") ||
      location?.pathname?.includes("/workspace/help-desk/details/");

   // The ticket list itself (admin "Ticket history" and workspace "Help
   // desk") has no page to go back to — isWorkspaceDetail below would
   // otherwise still catch it (it matches on "/help-desk" alone) and show
   // a back button with no label/destination.
   const isTicketList =
      location?.pathname?.includes("/admin/help-desk/list") ||
      location?.pathname?.includes("/workspace/help-desk/list");

   // Results and Action plan (the base assessment-level page, not its
   // sub-views which already have their own dedicated back-links below)
   // show a "Workspace / X" breadcrumb, same treatment as Resources.
   const isResultsPage = location.pathname.includes("/workspace/results/results/");
   const isActionPlanPage =
      location.pathname.includes("/workspace/results/action-plan/") &&
      !location.pathname.includes("/view") &&
      !location.pathname.includes("/organization/") &&
      !location.pathname.includes("/survey-results");

   // The Organizations management list itself — its /details/:id
   // sub-route already gets a dedicated back-link further below
   // (isORGManagementInDonor/isSuperAdminManagement), so exclude it here.
   const isOrgManagementListPage =
      location.pathname.includes("/workspace/organization-management/") &&
      !location.pathname.includes("/details/");

   const isSettings =
      location?.pathname?.includes("/admin/account-summary") ||
      location?.pathname?.includes("/admin/profile-information") ||
      location?.pathname?.includes("/admin/login-information") ||
      location?.pathname?.includes("/admin/payment-information");

   const isProfileNotAdmin =
      (!AuthService.isAuthorized([UserRolesEnum.SuperAdmin]) &&
         location?.pathname?.includes("/account-summary")) ||
      location?.pathname?.includes("/profile-information") ||
      location?.pathname?.includes("/login-information");

   const selectedAssessmentId = localStorage.getItem("selectedAssessmentId");
   const selectedSectionId = localStorage.getItem("selectedSectionId");
   const selectedSurveyId = localStorage.getItem("selectedSurveyId");

   // Change fullName if name Edited //
   useEffect(() => {
      setFullName(AuthService?.getFullName());
   }, [fullNameChanged]);

   const logout = () => {
      AuthService.logout();
      navigate("/auth/login");
   };

   const layoutProps = useMemo(() => {
      return {
         config: uiService.config,
         subheaderFixed: objectPath.get(uiService.config, "subheader.fixed"),
         subheaderMobileToggle: objectPath.get(uiService.config, "subheader.mobile-toggle"),
         subheaderCssClasses: uiService.getClasses("subheader", true),
         subheaderContainerCssClasses: uiService.getClasses("subheader_container", true)
      };
   }, [uiService]);

   useLayoutEffect(() => {
      const aside = getBreadcrumbsAndTitle("kt_aside_menu", location.pathname);
      const header = getBreadcrumbsAndTitle("kt_header_menu", location.pathname);
      const breadcrumbs =
         aside && aside.breadcrumbs.length > 0 ? aside.breadcrumbs : header.breadcrumbs;
      subheader.setBreadcrumbs(breadcrumbs);
      subheader.setTitle(
         aside && aside.title && aside.title.length > 0 ? aside.title : header.title
      );

      // eslint-disable-next-line
   }, [location.pathname]);

   useEffect(() => {
      // Call setUser whenever the user changes
      setUser(AuthService?.getUser());
   }, []);

   const {
      notifications,
      markNotificationAsRead,
      markAllNotificationsAsRead,
      setUser,
      pageNumber,
      loadingMarkAllRead,
      loadingMarkOneRead,
      setPopoverUnreadCount,
      setPopoverUnreadCountAll,
      setPopoverIncCount,
      toggleBell,
      handleCloseBell
   } = useContext(NotificationContext);

   // Do not remove this useEffect, need from update title/breadcrumbs outside (from the page)
   useEffect(() => {}, [subheader]);

   const isHumanitarian = AuthService.isAuthorized([UserRolesEnum.Consultant]);

   const { imageLoading, profileImage, setImageLoading, setProfileImage } = useAvatarStore();
   const getProfilePic = async () => {
      setImageLoading(true);
      try {
         await httpService.get(`Accounts/get-profile-picture?userId=${user?.id}`, async (res) => {
            const fileKey = res?.message;

            if (fileKey) {
               const fileUrl = `${process.env.REACT_APP_FILE_MANAGEMENT}FileData/getFileByFileKey?platformId=${process.env.REACT_APP_PLATFORM_KEY}&fileKey=${fileKey}`;
               const response = await Axios.get(fileUrl);

               if (response?.data?.data) {
                  setProfileImage(response?.data?.data);
               } else {
                  console.error("No image URL found in the file management response.");
               }
            } else {
               console.error("No file key found in the response.");
            }
         });
      } catch (error) {
         console.error("Error fetching profile picture:", error);
      } finally {
         setImageLoading(false);
      }
   };

   useEffect(() => {
      if (isHumanitarian) {
         getProfilePic();
      }
   }, [isHumanitarian]);

   function useIsIpad(breakpoint = 991) {
      const [isMobile, setIsMobile] = useState(window.innerWidth <= breakpoint);

      useEffect(() => {
         const handleResize = () => {
            setIsMobile(window.innerWidth <= breakpoint);
         };
         window.addEventListener("resize", handleResize);
         return () => window.removeEventListener("resize", handleResize);
      }, [breakpoint]);

      return isMobile;
   }

   const isMobile = useIsIpad();
   return (
      <div
         id="kt_subheader"
         className={`subheader py-2 py-lg-4 ${layoutProps.subheaderCssClasses}`}
         style={{ backgroundColor: "#fff" }}
      >
         <div
            className={`full-width d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap`}
         >
            <div className="d-flex align-items-center flex-wrap mr-1">
               {layoutProps.subheaderMobileToggle && (
                  <button
                     className="burger-icon burger-icon-left mr-4 d-inline-block d-lg-none"
                     id="kt_subheader_mobile_toggle"
                  >
                     <span />
                  </button>
               )}
            </div>

            <div
               className="pl-4 pl-md-10 pr-4 pr-md-10 pt-3 pt-lg-0 pb-3 pb-lg-0 d-flex w-100 align-items-center justify-content-between flex-wrap cursor-pointer header-mobile-top"
               style={{
                  gap: "10px"
                  // paddingLeft: "40px",
               }}
            >
               {isResourcesPage ? (
                  <div
                     className="d-flex align-items-center"
                     style={{ color: "#8c8c8c", fontSize: "13px", fontFamily: "Lato", gap: "4px" }}
                  >
                     <Link
                        to={isSuperAdmin ? "/admin/workspace" : "/workspace"}
                        style={{ color: "#8c8c8c" }}
                     >
                        {t("workspace-breadcrumb-label")}
                     </Link>
                     <span>/</span>
                     <Link
                        to={
                           resourcesActiveTab === "collections"
                              ? "/workspace/resources?tab=collections"
                              : "/workspace/resources"
                        }
                        style={{ color: "#8c8c8c" }}
                     >
                        {resourcesActiveTab === "collections"
                           ? t("collections-tab-label")
                           : t("resources-breadcrumb-label")}
                     </Link>
                  </div>
               ) : isExpertGuidedList || isExpertGuidedAssessment ? (
                  <div
                     className="d-flex align-items-center"
                     style={{ fontSize: "13px", fontFamily: "Lato", gap: "4px" }}
                  >
                     <Link to="/workspace" style={{ color: "#8c8c8c" }}>
                        {t("workspace-breadcrumb-label")}
                     </Link>
                     <span style={{ color: "#8c8c8c" }}>/</span>
                     {isExpertGuidedAssessment ? (
                        <>
                           <Link
                              to="/workspace/assessment/guided-assessment/list"
                              style={{ color: "#8c8c8c" }}
                           >
                              {t("guided-assessments-menu-item")}
                           </Link>
                           <span style={{ color: "#8c8c8c" }}>/</span>
                           <span style={{ color: "#3A3737" }}>{t("assessment-word")}</span>
                        </>
                     ) : (
                        <span style={{ color: "#3A3737" }}>{t("guided-assessments-menu-item")}</span>
                     )}
                  </div>
               ) : isStaffModulePreview ? (
                  <div
                     className="d-flex align-items-center"
                     style={{ fontSize: "13px", fontFamily: "Lato", gap: "4px" }}
                  >
                     <Link to="/workspace/task-management" style={{ color: "#8c8c8c" }}>
                        {t("task-management-title")}
                     </Link>
                     <span style={{ color: "#8c8c8c" }}>/</span>
                     <span style={{ color: "#3A3737" }}>{t("module-label")}</span>
                  </div>
               ) : isTicketDetails ? (
                  <div
                     className="d-flex align-items-center"
                     style={{ fontSize: "14px", fontFamily: "Poppins", gap: "6px" }}
                  >
                     <Link
                        to={isSuperAdmin ? "/admin/help-desk/list" : "/workspace/help-desk/list"}
                        style={{ color: "#777777" }}
                     >
                        {isSuperAdmin ? t("menu-item-tickets") : t("help-desk-title")}
                     </Link>
                     <span style={{ color: "#C1C1C1" }}>/</span>
                     <span style={{ color: "#3A3737", fontWeight: 500 }}>
                        {t("ticket-preview-title")}
                     </span>
                  </div>
               ) : isTicketList ? (
                  <div></div>
               ) : isResultsPage || isActionPlanPage ? (
                  <div
                     className="d-flex align-items-center"
                     style={{ color: "#8c8c8c", fontSize: "13px", fontFamily: "Lato", gap: "4px" }}
                  >
                     {isDashboardEditMode ? (
                        <>
                           <Link
                              to={isSuperAdmin ? "/admin/workspace" : "/workspace"}
                              style={{ color: "#8c8c8c" }}
                           >
                              {t("workspace-breadcrumb-label")}
                           </Link>
                           <span>/</span>
                           <span
                              role="button"
                              tabIndex={0}
                              style={{ color: "#8c8c8c", cursor: "pointer" }}
                              onClick={() => setDashboardEditMode(false)}
                           >
                              {isResultsPage
                                 ? t("results-breadcrumb-label")
                                 : t("action-plan-breadcrumb-label")}
                           </span>
                           <span>/</span>
                           <span style={{ color: "#8c8c8c" }}>{t("edit-dashboard-button")}</span>
                        </>
                     ) : (
                        <>
                           <Link
                              to={isSuperAdmin ? "/admin/workspace" : "/workspace"}
                              style={{ color: "#8c8c8c" }}
                           >
                              {t("workspace-breadcrumb-label")}
                           </Link>
                           <span>/</span>
                           <span style={{ color: "#8c8c8c" }}>
                              {isResultsPage
                                 ? t("results-breadcrumb-label")
                                 : t("action-plan-breadcrumb-label")}
                           </span>
                        </>
                     )}
                  </div>
               ) : isOrgManagementListPage ? (
                  <div
                     className="d-flex align-items-center"
                     style={{ color: "#8c8c8c", fontSize: "13px", fontFamily: "Lato", gap: "4px" }}
                  >
                     <Link
                        to={isSuperAdmin ? "/admin/workspace" : "/workspace"}
                        style={{ color: "#8c8c8c" }}
                     >
                        {t("workspace-breadcrumb-label")}
                     </Link>
                     <span>/</span>
                     <span style={{ color: "#8c8c8c" }}>
                        {t("organizations-management-title")}
                     </span>
                  </div>
               ) : isViewActionPlan ||
               isWorkspaceDetail ||
               isEditSurveyDetail ||
               isTemplatePreview ||
               isEditAssessment ||
               isSelfAssessment ||
               isGuidedAssessmentInExpert ||
               isORGManagementInDonor ||
               isSuperAdminManagement ||
               isGuidedAssessmentExpert ||
               isStaffActionPlan ||
               isManagerActionPlan ||
               isApproverModuleReview ||
               isProfileNotAdmin ||
               isActionPlanManager ||
               isSettings ? (
                  // isAdminTickets
                  <Link
                     to={
                        isViewActionPlan || isActionPlanManager
                           ? `/workspace/results/action-plan/${selectedAssessmentId}/`
                           : isEditSurveyPreview
                           ? `/admin/module?page=${pageNumber}`
                           : isEditSurveyDetail
                           ? `/admin/module?page=${pageNumber}`
                           : isTemplatePreview
                           ? `/admin/module?page=${pageNumber}&tab=templates`
                           : isConsultantORGView
                           ? `/workspace/results/action-plan/${selectedAssessmentId}/view/${selectedSurveyId}/${selectedSectionId}`
                           : isEditAssessment
                           ? `/admin/assessment?page=${pageNumber}`
                           : isSelfAssessment
                           ? `/workspace/assessment/self-assessment/${selfAssessmentId}`
                           : isStaffActionPlan
                           ? "/workspace/task-management/"
                           : isManagerActionPlan
                           ? "/workspace/survey-request/"
                           : isApproverModuleReview
                           ? "/approver/submissions"
                           : isORGManagementInDonor
                           ? `/workspace/organization-management?page=${pageNumber}`
                           : isSuperAdminManagement
                           ? `/workspace/organization-management?page=${pageNumber}`
                           : isGuidedAssessmentInExpert
                           ? `/workspace/assessment/guided-assessment/surveys/${savedRecord}`
                           : isGuidedAssessmentExpert
                           ? `/workspace/assessment/guided-assessment/list/`
                           : isAdminTickets ||
                             isWorkspaceDetail ||
                             isEditSurveyDetail ||
                             isTemplatePreview ||
                             isEditAssessment ||
                             isSuperAdminManagement
                           ? ""
                           : isSuperAdmin
                           ? `/admin/workspace`
                           : `/workspace`
                     }
                     className="d-flex align-items-center"
                     style={{ color: "#777777", fontSize: "14px", fontWeight: 500 }}
                  >
                     {/* {!isAdminTickets && !isORGManagementInDonor && !isSuperAdminManagement && ( */}
                     <img src={GoBack} alt="GoBack" style={{ marginRight: "10px" }} />
                     {/* )} */}
                     {isDetailPage || isORGManagementInDonor || isSuperAdminManagement
                        ? t("go-back-to-organizations-link")
                        : isViewActionPlan || isActionPlanManager
                        ? t("go-back-to-action-plan-link")
                        : isEditSurveyPreview
                        ? t("go-back-to-module-list-link")
                        : isEditSurveyDetail
                        ? t("go-back-to-modules-list-link")
                        : isTemplatePreview
                        ? t("go-back-to-templates-list-link")
                        : isConsultantORGView
                        ? t("go-back-to-action-plan-section-link")
                        : isEditAssessment
                        ? t("go-back-to-assessment-link")
                        : isSelfAssessment
                        ? t("go-back-to-assessments-link")
                        : isStaffActionPlan
                        ? t("go-back-to-assigned-modules-list-link")
                        : isManagerActionPlan
                        ? t("go-back-to-approved-modules-list-link")
                        : isApproverModuleReview
                        ? t("go-back-to-pending-modules-list-link")
                        : isGuidedAssessmentInExpert
                        ? t("go-back-to-guided-assessment-link")
                        : isGuidedAssessmentExpert
                        ? t("go-back-to-guided-assessment-list-link")
                        : isAdminTickets
                        ? ""
                        : t("go-back-to-workspaces-link")}
                  </Link>
               ) : (
                  <div></div>
               )}
               {!isMobile && (
                  <div
                     className="subheader-rigth d-flex align-items-center"
                  >
                     {AuthService?.isAuthorized([
                        UserRolesEnum.SuperAdmin,
                        UserRolesEnum.Manager,
                        UserRolesEnum.Consultant,
                        UserRolesEnum.Staff,
                        UserRolesEnum.NationalOrganization
                     ]) && (
                        <>
                           <NotificationPopover
                              toggleBell={toggleBell}
                              user={user}
                              handleCloseBell={handleCloseBell}
                              notifications={notifications}
                              markNotificationAsRead={markNotificationAsRead}
                              markAllNotificationsAsRead={markAllNotificationsAsRead}
                              loadingMarkAllRead={loadingMarkAllRead}
                              loadingMarkOneRead={loadingMarkOneRead}
                              setPopoverUnreadCount={setPopoverUnreadCount}
                              setPopoverUnreadCountAll={setPopoverUnreadCountAll}
                              setPopoverIncCount={setPopoverIncCount}
                           />
                        </>
                     )}
                     {
                        <LanguageSwitcher />
                     }
                     <div onClick={handleClick} style={{ cursor: "pointer" }}>
                        <div className="username">
                           <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                              {isHumanitarian ? (
                                 imageLoading ? (
                                    <Spin />
                                 ) : (
                                    <img
                                       src={profileImage || UserIcon}
                                       alt={t("profile-preview-alt-text")}
                                       className="avatar"
                                       style={{ borderRadius: "50%" }}
                                    />
                                 )
                              ) : (
                                 <Avatar className="avatar">
                                    {fullName?.charAt(0).toUpperCase()}
                                 </Avatar>
                              )}

                              <div
                                 className="d-flex flex-column"
                                 style={{
                                    maxWidth: "125px"
                                 }}
                              >
                                 <div
                                    style={{
                                       // maxWidth: "65px",
                                       display: "inline-block"
                                    }}
                                 >
                                    <p className="fullnameParagraph">{fullName}</p>
                                 </div>
                                 <div
                                    style={{
                                       // maxWidth: "65px",
                                       display: "inline-block"
                                    }}
                                 >
                                    <p className="roleParagraph">
                                       {user?.roles?.length
                                          ? user?.roles[0]?.name === "National Organization"
                                             ? t("org-role-abbreviation")
                                             : translateRoleName(user?.roles[0]?.name, t)
                                          : ""}
                                    </p>
                                 </div>
                              </div>
                           </div>
                           <img
                              src={ChevronDown}
                              alt={t("account-menu-toggle-alt")}
                              aria-controls="simple-popover"
                              aria-haspopup="true"
                              data-toggle="modal"
                              data-target="#kt_chat_modal"
                           />
                        </div>
                     </div>

                     <PopoverLinks
                        anchorEl={anchorEl}
                        handleClose={closePopover}
                        logout={logout}
                        isSuperAdmin={isSuperAdmin}
                        isNgo={isNgo}
                     />
                  </div>
               )}
            </div>
         </div>
      </div>
   );
}
